export const REGIONAL_ZOOM_SCALE = 1.5;
export const DETAIL_ZOOM_SCALE = 2.5;
export const OVERVIEW_TO_REGIONAL_ZOOM = 1.65;
export const REGIONAL_TO_OVERVIEW_ZOOM = 1.35;
export const REGIONAL_TO_DETAIL_ZOOM = 2.65;
export const DETAIL_TO_REGIONAL_ZOOM = 2.35;
export const OVERVIEW_MARKER_LIMIT = 10;
export const REGIONAL_MARKER_LIMIT = 20;
export const MAX_OVERVIEW_MARKER_LIMIT = 24;
export const MAX_REGIONAL_MARKER_LIMIT = 36;
export const COMPACT_MAP_WIDTH = 520;
export const COMPACT_MAP_HEIGHT = 320;
export const COMPACT_OVERVIEW_MARKER_LIMIT = 3;
export const COMPACT_REGIONAL_MARKER_LIMIT = 4;
export const OVERVIEW_MARKER_AREA = 32_000;
export const REGIONAL_MARKER_AREA = 24_000;
export const MARKER_WIDTH = 144;
export const MARKER_HEIGHT = 44;
export const MARKER_GAP = 8;
export const MARKER_SETTLE_DELAY = 180;
